"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var parkingLotApi = _interopRequireWildcard(require("@/api/parkingLotApi"));
var _ParkingLotDialog = _interopRequireDefault(require("./components/ParkingLotDialog.vue"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'ParkingLotList',
  components: {
    ParkingLotDialog: _ParkingLotDialog.default
  },
  data: function data() {
    return {
      constants: this.$constants,
      listPram: {
        page: 1,
        limit: this.$constants.page.limit[0],
        parkName: '',
        parkCode: ''
      },
      listData: {
        list: [],
        total: 0
      },
      listLoading: false
    };
  },
  mounted: function mounted() {
    this.handlerGetListData();
  },
  methods: {
    handlerGetListData: function handlerGetListData() {
      var _this = this;
      this.listLoading = true;
      parkingLotApi.getParkingLotList(this.listPram).then(function (data) {
        _this.listData = data;
        _this.listLoading = false;
      }).catch(function () {
        _this.listLoading = false;
      });
    },
    handleSearch: function handleSearch() {
      this.listPram.page = 1;
      this.handlerGetListData();
    },
    handleReset: function handleReset() {
      this.listPram = {
        page: 1,
        limit: this.$constants.page.limit[0],
        parkName: '',
        parkCode: ''
      };
      this.handlerGetListData();
    },
    handleAdd: function handleAdd() {
      this.$refs.parkingLotDialogRef.open({});
    },
    handleEdit: function handleEdit(row) {
      var _this2 = this;
      parkingLotApi.getParkingLotDetail(row.id).then(function (res) {
        _this2.$refs.parkingLotDialogRef.open(res);
      }).catch(function () {
        _this2.$message.error('获取停车场详情失败');
      });
    },
    handleDelete: function handleDelete(row) {
      var _this3 = this;
      this.$confirm('确定要删除该停车场吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        parkingLotApi.deleteParkingLot(row.id).then(function () {
          _this3.$message.success('删除成功');
          _this3.handlerGetListData();
        }).catch(function () {
          _this3.$message.error('删除失败');
        });
      });
    },
    handleSizeChange: function handleSizeChange(val) {
      this.listPram.limit = val;
      this.handlerGetListData();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.listPram.page = val;
      this.handlerGetListData();
    }
  }
};